<template>
  <div>
    <van-nav-bar c title="登录"/>
    <van-form>
      <van-field v-model="username" autofocus label="用户名" name="用户名" placeholder="用户名"/>
      <van-field v-model="password" label="密码" name="密码" placeholder="密码" type="password"/>
      <van-field :value="type.name" clickable label="登录类型" name="loginType" placeholder="点击选择登录类型" readonly @click="showLoginTypeClick"/>
      <van-popup v-model="showLoginType" position="bottom">
        <van-picker :columns="types" show-toolbar value-key="name" @cancel="showLoginType = false" @confirm="onConfirmTypeArr"/>
      </van-popup>
      <van-field :value="warehouse.name" clickable label="仓库" name="whPicker" placeholder="点击选择仓库" readonly @click="showPicker"/>
      <van-popup v-model="showWhPicker" position="bottom">
        <van-picker :columns="warehouses" show-toolbar value-key="name" @cancel="showWhPicker = false" @confirm="onConfirmWhArr"/>
      </van-popup>
      <van-field :value="ip.name" clickable label="配置打印机" name="ipPicker" placeholder="点击选择打印机名称" readonly @click="showPickerIp"/>
      <van-popup v-model="showIpPicker" position="bottom">
        <van-picker :columns="ips" show-toolbar value-key="name" @cancel="showIpPicker = false" @confirm="onConfirmIpArr"/>
      </van-popup>
      <div style="margin: 8px;">
        <van-button block round type="info" @click="login">登录</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { findOne, post } from '@/api/Api'
import { Dialog, Toast } from 'vant'
import { setEnterpriseId, setIp, setType, setUser, setUserId, setWarehouseId } from '@/pdaView/utils'
import Vue from 'vue'
import { ACCESS_TOKEN, ENTERPRISE, OPERATOR, WAREHOUSE } from '@/store/mutation-types'
import api from '@/api'
import { Warehouse } from '@/api/dto/common/Warehouse'

export default {
  name: 'test',
  data() {
    return {
      username: '',
      password: '',
      warehouse: new Warehouse(),
      warehouses: [],
      ips: [],
      types: [
        { id: 'RF', name: 'PDA' }, { id: 'PAD', name: '平板' }
      ],
      showIpPicker: false,
      showWhPicker: false,
      showLoginType: false,
      ip: { id: '', name: '' },
      type: { id: '', name: '' }
    }
  },
  mounted() {
    console.log(this.$device)
    if (this.$device.isMobile) {
      console.log('This is a mobile device.')
    }
    if (this.$device.isIos) {
      console.log('This is an iOS device.')
    }
  },
  methods: {
    login() {
      setWarehouseId(this.warehouse.id)
      if (!this.username) {
        Dialog({ message: '请输入用户名' })
        return
      }
      if (!this.password) {
        Dialog({ message: '请输入密码' })
        return
      }
      if (this.type.id === '') {
        Dialog({ message: '请选择登录类型' })
        return
      }
      if (this.warehouse.isNew()) {
        Dialog({ message: '请选择仓库' })
        return
      }
      if (this.ip.id === '') {
        Dialog({ message: '请选择打印机' })
        return
      }
      const args = {
        username: this.username,
        password: this.password,
        appname: this.type.id
      }
      Vue.ls.remove(ACCESS_TOKEN)
      post(api.adminAuthLogin, {}, args).then(res => {
        if (res.success) {
          setUser(res.result)
          setUserId(res.result.id)
          setEnterpriseId(res.result.enterprise.id)
          setWarehouseId(this.warehouse.id)
          setType(this.type.id)
          setIp(this.ip.id)
          Vue.ls.set(ACCESS_TOKEN, res.result.token)
          Vue.ls.set(OPERATOR, res.result)
          Vue.ls.set(ENTERPRISE, res.result.enterprise)
          Vue.ls.set(WAREHOUSE, this.warehouse)
          if (this.type.id === 'RF') {
            this.$router.push({ name: 'PdaIndex' }, () => {
              Toast('登陆成功')
            })
          } else {
            this.$router.push({ name: 'PadIndex' }, () => {
              Toast('登陆成功')
            })
          }
        }
      })
    },
    onConfirmIpArr(item) {
      this.ip = item
      this.showIpPicker = false
    },
    onConfirmTypeArr(item) {
      this.type = item
      this.showLoginType = false
    },
    onConfirmWhArr(item) {
      this.warehouse = new Warehouse(item)
      this.showWhPicker = false
      findOne('fieldFactory', { no: 'PRINTER', 'enterprise.id': this.warehouse.enterprise.id, 'warehouse.id': this.warehouse.id }).then(res => {
        if (res.success) {
          this.ips = res.result.dictionaries
        }
      })
    },
    showPicker() {
      this.showWhPicker = true
      if (!this.username) {
        Dialog({ message: '请输入用户名' })
        return
      }
      if (!this.type) {
        Dialog({ message: '请选择登录类型' })
        return
      }
      const args = {
        username: this.username,
        appname: this.type.id
      }
      post(api.connect, {}, args).then(res => {
        if (res.success) {
          this.warehouses = res.result.map(it => {
            return new Warehouse(it)
          })
        } else {
          Dialog({ message: res.result })
        }
      })
    },
    showPickerIp() {
      if (!this.warehouse) {
        Dialog({ message: '请选择仓库' })
      } else {
        this.showIpPicker = true
      }
    },
    showLoginTypeClick() {
      this.showLoginType = true
    }
  }
}
</script>